import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';


import useAuth from 'hooks/useAuth'
import CardLoggedOut from 'components/CardLoggedOut';
import getIcon from 'utils/getIcon';
import { Divider } from '@mui/joy';

export default function RequestEmailRedirect() {

    const { checkingAuth, currentUser } = useAuth();
    const { requestKey } = useParams();
    const navigate = useNavigate();
    const RefreshIcon = getIcon("Replay");


    // Redirect to the request page if the user is logged in
    useEffect(() => {
        if (!checkingAuth && currentUser?.key) {
            navigate(`/request/${requestKey}`);
        }
    }, [currentUser?.key, checkingAuth, navigate]);


    return (
        <CardLoggedOut >
            {checkingAuth &&
                <Stack>
                    <Typography
                        endDecorator={
                            <RefreshIcon />
                        }
                    >
                        Checking auth...
                    </Typography>
                </Stack>
            }

            {!checkingAuth &&
                <Stack spacing={2}>
                    <Divider />
                    <Stack alignItems="center">


                        <Typography
                            level="h3">
                            You're in the right place.
                        </Typography>

                        <Typography
                            level="body-xs"
                        >
                            We've
                            <Typography
                                mx={0.5}
                                color="success"
                                variant="soft">upgraded</Typography>almost everything.

                        </Typography>

                        <Stack
                            direction="column"
                            spacing={2}
                            mt={2}
                            alignItems="center"
                        >


                            <Button
                                color="primary"
                                variant="outlined"
                                fullWidth
                             onClick={() => navigate(`/login?redirect=/request/${requestKey}`)}>
                                Log In
                            </Button>

                        </Stack>
                    </Stack>
                </Stack>
            }

        </CardLoggedOut>

    );
}
